/** Snapshot shape for video editor undo/redo (timeline + related editor state). */

export const VIDEO_EDITOR_HISTORY_MAX = 50;

export function cloneEditorSnapshot(snapshot) {
  return JSON.parse(JSON.stringify(snapshot));
}

export function captureVideoEditorSnapshot({
  videoTracks,
  audioTracks,
  musicTracks,
  subtitleTracks,
  effectTracks,
  overlayTracks,
  subtitleStyle,
  videoBookends,
  timelineActive,
  audioTrackMeta,
  editorAnimationSpeed,
}) {
  return {
    videoTracks: videoTracks || [[]],
    audioTracks: audioTracks || [[]],
    musicTracks: musicTracks || [[]],
    subtitleTracks: subtitleTracks || [[]],
    effectTracks: effectTracks || [[]],
    overlayTracks: overlayTracks || [[]],
    subtitleStyle: subtitleStyle || {},
    videoBookends: videoBookends || {},
    timelineActive: timelineActive || {},
    audioTrackMeta: audioTrackMeta || [],
    editorAnimationSpeed: editorAnimationSpeed ?? 1,
  };
}

export function snapshotsEqual(a, b) {
  if (!a || !b) return false;
  try {
    return JSON.stringify(a) === JSON.stringify(b);
  } catch {
    return false;
  }
}
